import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { CheckIcon } from "@heroicons/react/24/solid"
import { url as cmsUrl } from "aldoo-ra/CMS/url"
import PubSub from "pubsub-js"
import { getHighlightEntry, resolveHighlight } from "./helpers"

export default function EnterpriseCard({ plan, storeData, texts, features }) {
  const productId = typeof plan.product === "string" ? plan.product : (plan.product?.item || plan.product?._id)
  const product = storeData?.products?.[productId]

  return (
    <div className="relative flex flex-col rounded-2xl border border-primary/20 p-6 shadow-sm hover:shadow-lg transition-shadow bg-gradient-to-br from-primary/[0.5] via-paper to-paper/70">
      {product?.thumbnail && (
        <img src={cmsUrl(product.thumbnail)} alt={plan.name} className="w-16 h-16 object-contain mb-3 mx-auto" />
      )}
      <Typography variant="h3" className="text-text mb-1 text-center">
        {plan.name}
      </Typography>

      {plan.tagline && (
        <Typography variant="txt1_dim" className="block min-h-[40px] my-4">
          {plan.tagline}
        </Typography>
      )}

      <div className="min-h-[90px] mb-4">
        <span className="text-4xl font-bold text-text">
          {texts?.custom}
        </span>
        <span className="text-text_secondary text-sm invisible">
          {texts?.perMonth}
        </span>
        <p className="text-xs text-text_secondary mt-1 invisible">
          placeholder
        </p>
      </div>

      <Button
        variant="primary"
        className="w-full mb-6"
        onClick={() => PubSub.publish("open-contacts", { category: "sales" })}
      >
        {plan.cta_label || texts?.contactUs}
      </Button>

      {plan.highlights && (() => {
        const items = Array.isArray(plan.highlights)
          ? plan.highlights
          : Object.values(plan.highlights)
        return items.length > 0 && (
          <ul className="space-y-2">
            {items.map((item, i) => {
              const { name, value } = getHighlightEntry(item, plan, product, features)
              if (!name) return null
              return (
                <li key={i} className="flex items-start gap-2 text-sm text-text">
                  <CheckIcon className="w-4 h-4 text-success shrink-0 mt-0.5" />
                  <span>
                    <span className="text-text_secondary">{resolveHighlight(name, product)}</span>
                    {value && (
                      <span className="font-semibold text-text">{" "}{resolveHighlight(value, product)}</span>
                    )}
                  </span>
                </li>
              )
            })}
          </ul>
        )
      })()}
    </div>
  )
}